const _ = "_rating_1h49l_1", t = "_rating__stars_1h49l_6", n = "_rating__textContainer_1h49l_196", r = "_rating__reviewLink_1h49l_274", i = "_rating__review_1h49l_274", a = "_rating__number_1h49l_282", e = {
  rating: _,
  rating__stars: t,
  rating__textContainer: n,
  rating__reviewLink: r,
  rating__review: i,
  rating__number: a
};
export {
  e as s
};
